<template lang='pug'>
    v-main
      v-container(fluid)
        v-flex
          v-card
            v-toolbar(class="elevation-0" color='white')
              v-toolbar-title(v-model="title") {{ title }}
            v-divider
            div(style="margin: .5rem; font-size: 14px;")
              span Information : &nbsp;&nbsp;
              v-icon(small color="blue") remove_red_eye 
              span &nbsp; View Detail &nbsp;&nbsp;&nbsp;
              v-icon(small color="green") cloud_download 
              span &nbsp; Download File &nbsp;&nbsp;&nbsp;
            v-divider
            v-toolbar(class="elevation-0 mt-2 mb-4" color='white')
              v-select(
                multiple 
                label="Business Unit" 
                :items="dataBisnisUnit" 
                item-value="value" 
                v-model="bisnisUnit" 
                hide-details 
                class='hidden-sm-and-down col-3 pl-0'
              )
                template(v-slot:prepend-item)
                  v-list-item(ripple @mousedown.prevent @click="toggle") 
                    v-list-item-action
                      v-icon(:color="bisnisUnit.length > 0 ? 'indigo darken-4' : ''") {{ iconX }} 
                    v-list-item-content
                      v-list-item-title Select All
                  v-divider(class="mt-2")

                template(v-slot:selection="{ item, index }")
                  v-chip(
                    v-if="bisnisUnit.length == 1"
                    close
                    @click:close="remove(bisnisUnit, 'bisnis unit')"
                  )
                    span {{ item.text | truncate(20, '...') }}
                  v-chip(
                    v-else-if="index===1"
                    close
                    @click:close="removeAll('bisnis unit')"
                  )
                    span {{ bisnisUnit.length }} Business Unit
              span(class="pr-1")
              v-select(
                label="IM Type"
                v-model="filterImType"
                hide-details 
                multiple
                :items="dataImType"
                class="hidden-sm-and-down col-2 pl-0"
                item-value="value"
              )
                template(v-slot:prepend-item)
                  v-list-item(ripple @mousedown.prevent @click="toggleImType") 
                    v-list-item-action
                      v-icon(:color="filterImType.length > 0 ? 'indigo darken-4' : ''") {{ iconXimType }} 
                    v-list-item-content
                      v-list-item-title Select All
                  v-divider(class="mt-2")

                template(v-slot:selection="{ item, index }")
                  v-chip(
                    v-if="filterImType.length == 1"
                    close
                    @click:close="remove(filterImType, 'imType')"
                  )
                    span {{ item.text }}
                  v-chip(
                    v-else-if="index===1"
                    close
                    @click:close="removeAll('imType')"
                  )
                    span {{ filterImType.length }} Type
              span(class="pr-1")
              v-select(
                multiple 
                label="Status" 
                hide-details 
                v-model="e3" 
                :items="dataStatus" 
                class="hidden-sm-and-down col-2 pl-0"
              )
                template(v-slot:prepend-item)
                  v-list-item(ripple @mousedown.prevent @click="toggleStatus") 
                    v-list-item-action
                      v-icon(:color="e3.length > 0 ? 'indigo darken-4' : ''") {{ iconXStatus }} 
                    v-list-item-content
                      v-list-item-title Select All
                  v-divider(class="mt-2")

                template(v-slot:selection="{ item, index }")
                  v-chip(
                    v-if="e3.length == 1"
                    close
                    @click:close="remove(e3, 'status')"
                  )
                    span {{ item.text }}
                  v-chip(
                    v-else-if="index===1"
                    close
                    @click:close="removeAll('status')"
                  )
                    span {{ e3.length }} Status

              span(class="pr-1")
              v-select(
                multiple 
                label="Category" 
                style="padding-bottom: 0.7rem;"
                hide-details 
                v-model="category" 
                :items="dataCategory" 
              )
                template(v-slot:prepend-item)
                  v-list-item(ripple @mousedown.prevent @click="toggleCategory") 
                    v-list-item-action
                      v-icon(:color="e3.length > 0 ? 'indigo darken-4' : ''") {{ iconXCategory }} 
                    v-list-item-content
                      v-list-item-title Select All
                  v-divider(class="mt-2")

                template(v-slot:selection="{ item, index }")
                  v-chip(
                    v-if="category.length == 1"
                    close
                    @click:close="remove(category, 'category')"
                  )
                    span {{ item.text }}
                  v-chip(
                    v-else-if="index===1"
                    close
                    @click:close="removeAll('category')"
                  )
                    span {{ category.length }} Category

              v-text-field(flat append-icon='search' placeholder='Keyword (optional)' v-model='keyword' hide-details class='hidden-sm-and-down col-3')
            v-divider
            v-card-text(class='pa-0')
              v-data-table.elevation-1(
                :headers="filterImType == 'General' ? im.headers : im.paymentHeaders"
                :items="im.items"
                :page.sync="page"
                :options.sync="options"
                :server-items-length="im.jumlah"
                :loading="loading"
                loading-text="Loading... Please wait"
                item-key='_id'
                :sort-desc.sync="im.imDate"
                multi-sortBy
                :single-expand="true"
                :expanded.sync='expanded'
                :search='keyword'
              )

                template(v-slot:item.imStatus='{ item }')
                  template(v-if="item.imWorkflow.length > 0")
                    v-chip(v-if="item.imWorkflow && item.imStatus === 3" label small :color="i18n.status[item.imStatus].color" style="width:100%;justify-content:space-evenly" text-color="black") Need Review
                    v-chip(v-else label small :color="i18n.status[item.imStatus].color" style="width:100%;justify-content:space-evenly" text-color="black") {{ item.imStatusLabel }}

                  template(v-else)
                    v-chip(:color="i18n.status[item.imStatus].color")
                    | {{ item.imStatusLabel }}

                //- template(v-slot:item.imStatus='{ item }')
                //-   v-chip(:color="i18n.status[item.imStatus].color")
                //-     | {{ i18n.status[item.imStatus].name }}

                template(v-slot:item.imDate='{ item }')
                    | {{ getUTC7Date(item.imDate) }}

                template(v-slot:item.actions='{ item }')
                  div(class="d-flex")
                    div
                      IMView(:imItems="item" :dialogType="dialogType" :title="title" :currencyConfigs="currencyConfigs")

                      v-icon.mr-2(v-if="item.imFileLampiran && item.imFileLampiran.length > 0" title="Download Attachment Files"  small='' color="green darken-1" @click='download(item.imNo)')
                        | cloud_download

                template(v-slot:no-data)
                  div.pa-15 
                    img(src="../assets/icon/empty.png")
                    div(class="empty__title mt-1") Data not found
                    div(class="empty__subtitle") Data is empty or Try adjusting your filters.

</template>
<style scoped>
.v-badge__badge {
  width: auto;
  border-radius: 12px;
  padding: 5px;
}
</style>

<script>
//import io from "socket.io-client";
import axios from "axios";
import * as i18n from "../data/i18n.json";
import IMView from "@/components/IMView.vue";
import { mapState } from "vuex";
export default {
  name: "IMListCC",
  components: {
    IMView,
  },
  props: {
    title: String,
    listType: String,
    dialogType: String,
    im: Object,
    header:Array
  },
  data() {
    return {
      filterImType:[],
      itemsPerPage: 10,
      page:1,
      i18n: i18n.default,
      dialog: false,
      e1: "",
      e2: "",
      e3: "",
      e6: 0,
      keyword: "",
      request:null,
      dataImType: [
        { text: "General", value: 5 },
        { text: "Payment", value: 6 },
        { text: "Announcement", value: 7 },
      ],
      options:{
        sortBy: ['imDate'],
        sortDesc: [true]
      },
      status_cc: [
        { text: "On Approval", value: "2" },
        { text: "Need Review", value: "3" },
        { text: "Rejected", value: "8" },
        { text: "Fully Approved", value: "4" },
        { text: "Withdraw", value: "5" }
      ],
      //socket: io.connect(this.$store.state.API_URL),
      imStat: "",
      wizardType: null,
      loading: false,
      bisnis_unit: [],
      bisnisUnit: '',
      expanded:[],
      category: "",
      dataCategory: i18n.category,
      currencyConfigs: {}
    };
  },
  mounted() {
    // this.group = this.$store.state.isImGroup ? this.group : 'nongroup';
    this.getBisnisUnit()
  },
  watch: {
    options(val){
        this.itemsPerPage = val.itemsPerPage
        this.getOptions()
    },

    keyword() {
      // this.getPagination();
       this.getOptions()
    },
    filterImType() {
      this.page=1
      // this.category = []
      // this.e3 = []
      this.getOptions()
    },
    bisnisUnit() {
      this.page=1
      // this.getPagination();
       this.getOptions()
    },
    e3() {
      this.page=1
      // this.getPagination();
       this.getOptions()
    },
    category() {
      this.page=1
      this.getOptions()
    }
  },
  beforeDestroy(){
    this.$store.state.dataReqCC.data = [];
    this.$store.state.dataReqCC.jumlah = 0
  },
  computed: {
    ...mapState(["dataUsers", "API_URL"]),
    search2: function() {
      return this.bisnisUnit + "_" + this.e3 + "_" + this.keyword;
    },
    dataTipe() {
      let result = [{ text: "All", value: "" }];
      for (const val in this.i18n.imType) {
        result.push({
          text: this.i18n.imType[val],
          value: val
        });
      }
      return result;
    },
    dataStatus() {
      return this.status_cc;
    },
    dataBisnisUnit() {
      return this.bisnis_unit;
    },

    selectAllImType () {
      return this.filterImType.length === this.dataImType.length
    },
    selectSomeImType () {
      return this.filterImType.length > 0 && !this.selectAllImType
    },
    iconXimType () {
      if (this.selectAllImType) return 'close'
      else if (this.selectSomeImType) return 'clear_all'
      else return 'check_box_outline_blank'
    },

    selectAllBU () {
      return this.bisnisUnit.length === this.dataBisnisUnit.length
    },
    selectSomeBU () {
      return this.bisnisUnit.length > 0 && !this.selectAllBU
    },
    iconX () {

      if (this.selectAllBU) return 'close'
      else if (this.selectSomeBU) return 'clear_all'
      else return 'check_box_outline_blank'
    },

    selectAllStatus () {
      return this.e3.length === this.dataStatus.length
    },
    selectSomeStatus () {
      return this.e3.length > 0 && !this.selectAllStatus
    },
    iconXStatus () {

      if (this.selectAllStatus) return 'close'
      else if (this.selectSomeStatus) return 'clear_all'
      else return 'check_box_outline_blank'
    },

    selectAllCategory () {
      return this.category.length === this.dataCategory.length
    },
    selectSomeCategory () {
      return this.category.length > 0 && !this.selectAllCategory
    },
    iconXCategory () {

      if (this.selectAllCategory) return 'close'
      else if (this.selectSomeCategory) return 'clear_all'
      else return 'check_box_outline_blank'
    },
  },
  methods: {
    async fetchCurrencyConfigs() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_OLD}/api/currency`)
        this.currencyConfigs = response.data
      } catch (error) {
        console.error('Error fetching currency configurations:', error)
        // Fallback to default configurations...
      }
    },
    getBisnisUnit() {
      setTimeout(()=> {
        let val = this.$store.state.dataUsers.user.bu
        for (let i in val ) {
          this.bisnis_unit.push({text:val[i].business_unit.bu_name, value: val[i].business_unit.id});
        }
        this.bisnis_unit.push({text:"Other", value: "other"});
      }, 1000)
    },
    getStatus(data, type, dataWf) {
      if ( type == 'status' ) {

        if(dataWf[0].status == 5) {
            if(data.status == 5) {
              return this.i18n.status[data.status].color;
            }
            return this.i18n.status[1].color;

        } else {
            if ( data.status == undefined ) {
              return this.i18n.status[1].color;
            }
            return this.i18n.status[data.status].color;
        }

      } else if ( type == 'icon' ) {

        if(dataWf[0].status == 5) {
            if(data.status == 5) {
              return this.i18n.status[data.status].icon;
            }
            return

        } else {

          if ( data.status == undefined ) {
            return
          }
          return this.i18n.status[data.status].icon;
        }
      }
    },
    download(imNo) {
      this.overlay = true;
      const URL = process.env.VUE_APP_API+`/requests/download_zip/`+imNo;
      axios.head(URL)
        .then(response => {
            const statusCode = response.status;
            if (statusCode === 404 || statusCode === 500) {
                this.overlay = false;
                this.$toasted.error('Download failed!', { icon : 'error'})
            } else {
                this.overlay = false;
                window.location.href = URL;
            }      
        })
        .catch(err => {
            this.overlay = false;
            this.$toasted.error('Download failed!', { icon : 'error'})
        })
    },

    cancel(){
      this.request.cancel()
    },
    getOptions() {
      clearTimeout(this._timerId)
      if(this.request) this.cancel(); 

      let token = localStorage.getItem("token");
      this._timerId = setTimeout(()=>{
        this.$store.state.dataReqCC.data = [];
        this.loading = true;
        const search = this.bisnisUnit + "_" + this.e3 + "_" + this.keyword;

        if ( this.options.page == undefined ) {
          this.options.page = 1
        }

        if ( this.options.rowsPerPage == undefined ) {
          this.options.rowsPerPage = this.itemsPerPage
        }
        

        const axiosSource = axios.CancelToken.source()
        this.request = {cancel:axiosSource.cancel}
        if (search.length != 2 && !this.options.sortBy) {
            axios
              .get(
                process.env.VUE_APP_API +
                `/requests/list/cc?status=${this.e3}&buId=${this.bisnisUnit}&category=${this.category}&keyword=${this.keyword}&page=${this.options.page}&perPage=${this.options.rowsPerPage}`,
                {
                  headers: { Authorization: `Bearer ${token}` },
                }
              )
              .then(res => {
                this.$store.state.dataReqCC.data = res.data.data;
                this.$store.state.dataReqCC.jumlah = res.data.total;
                this.request=null
              })
              .catch(err => {
                  console.log(err)
              })
              .finally(() => (this.loading = false));

        } else if (this.options.sortBy) {
          const direction = this.options.sortDesc[0] ? -1 : 1;
          let sortBy = this.options.sortBy;
          if (sortBy == "imNilai") sortBy = "imValue";
          if (sortBy == "imStatusLabel") sortBy = "imStatus";

            let token = localStorage.getItem("token");
            const config = {
              method: "post",
              url: process.env.VUE_APP_API + `/requests/list/cc`,
              headers: {"Authorization": `Bearer ${token}`},
              data: {
                "sortBy": sortBy[0],
                "direction": direction,
                "page": this.options.page,
                "perPage": this.options.rowsPerPage,
                "status": this.e3.length > 0 ? this.e3 : [],
                "category": this.category.length > 0 ? this.category : [],
                "keyword": this.keyword.trim(),
                "buId": this.bisnisUnit.length > 0 ? this.bisnisUnit : [],
              },
            };
            config.data.filterImType = this.filterImType == ''? []: this.filterImType,
            axios(config)
              .then(res => {
                  this.page = this.options.page
                  this.$store.state.dataReqCC.data = res.data.data;
                  this.$store.state.dataReqCC.jumlah = res.data.total;
                  this.request=null
              })
              .catch(err => {
                console.log(err)
              })
              .finally(() => (this.loading = false));

        } else if (search.length == 2) {
            const config = {
              method: "post",
              url: process.env.VUE_APP_API + `/requests/list/cc`,
              headers: {"Authorization": `Bearer ${token}`},
              data: {
                "buId": this.bisnisUnit.length > 0 ? this.bisnisUnit : [],
                "status": this.e3.length > 0 ? this.e3 : [],
                "category": this.category.length > 0 ? this.category : [],
                "direction": 1,
                "sortBy": sortBy[0],
                "keyword": search,
                "page": this.options.page,
                "perPage": this.options.rowsPerPage
              },
            };
            config.data.filterImType = this.filterImType == ''? []: this.filterImType,
            axios(config)
              .then(res => {
                this.$store.state.dataReqCC.data = res.data.data;
                this.$store.state.dataReqCC.jumlah = res.data.total;
                this.request=null
              })
              .catch(err => {
                console.log(err)
              })
              .finally(() => (this.loading = false));
        }
      },500)
    },
    getUTC7Date(tgl) {
      let tanggal = new Date(tgl);
      let month =
        tanggal.getMonth() + 1 < 10
          ? "0" + (tanggal.getMonth() + 1)
          : tanggal.getMonth() + 1;
      let date =
        tanggal.getDate() < 10
          ? "0" + tanggal.getDate()
          : tanggal.getDate();
      return tanggal.getFullYear() + "-" + month + "-" + date;
    },
    toggle () {
      this.$nextTick(() => {
        if (this.selectAllBU) {
          this.bisnisUnit = []
        } else {
          const dta = this.dataBisnisUnit.slice().filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i)
          let result = []
          for(let i in dta) result.push(dta[i].value)
          //- result.push({ text: "Other", value: "other" })
          this.bisnisUnit = result
        }
      })
    },
    toggleStatus () {
      this.$nextTick(() => {
        if (this.selectAllStatus) {
          this.e3 = []
        } else {
          const dta = this.dataStatus.slice().filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i)
          let result = []
          for(let i in dta) result.push(dta[i].value)
          this.e3 = result
        }
      })
    },
    toggleImType () {
      this.$nextTick(() => {
        // filterImType
        if (this.selectAllImType) {
          this.filterImType = []
        } else {
          const dta = this.dataImType.slice().filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i)
          let result = []
          for(let i in dta) result.push(dta[i].value)
          this.filterImType = result
        }
      })
    },
    toggleCategory() {
      this.$nextTick(() => {
        if (this.selectAllCategory) {
          this.category = []
        } else {
          const dta = this.dataCategory.slice().filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i)
          let result = []
          for(let i in dta) result.push(dta[i].value)
          this.category = result
        }
      })
    },
    remove(id, type) {
      if ( type == 'bisnis unit' ) {
        let idx = this.bisnisUnit.indexOf(id)
        this.bisnisUnit.splice(idx, 1)
        this.bisnisUnit = [...this.bisnisUnit]

      } else if ( type == 'status' ) {
        let idx = this.e3.indexOf(id)
        this.e3.splice(idx, 1)
        this.e3 = [...this.e3]

      } else if ( type == 'category' ) {
        let idx = this.category.indexOf(id)
        this.category.splice(idx, 1)
        this.category = [...this.category]
      } else if ( type == 'imType' ) {
        let idx = this.filterImType.indexOf(id)
        this.filterImType.splice(idx, 1)
        this.filterImType = [...this.filterImType]
      }
    },
    removeAll(type) {
      if ( type == 'bisnis unit' ) {
        this.bisnisUnit = ''
      } else if ( type == 'status' ) {
        this.e3 = ''
      } else if ( type == 'category' ) {
        this.category = ''
      } else if ( type == 'imType' ) {
        this.filterImType = []
      }
    }
  },
  async created(){
    await this.fetchCurrencyConfigs()
  }
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>



